import { h, hydrate, render } from "preact";

const host = document.querySelector("app-root")!;

let applicationStart: Promise<void> | null = null;

const start = () => {
  applicationStart ??= (async () => {
    const [{ AppRootReact }, { preloadRouteComponent }] = await Promise.all([
      import("./app-root-react"),
      import("route-components"),
    ]);

    await preloadRouteComponent(window.location.pathname);

    if (import.meta.env.PUBLIC_SSR_CLIENT) {
      hydrate(h(AppRootReact, { host }), host);
    } else {
      render(h(AppRootReact, { host }), host);
    }
  })();

  return applicationStart;
};

void start();
